module.exports = __webpack_public_path__ + "media/images/affirm_logo-06d1d9e568c79bd36d86812d06463525.png";